import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import { ModalTypes } from '../enums/modal-types';
import {ModalTemplates} from "../enums/modal-templates";
@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private subject = new Subject<any>();
  modal_data: any;

  constructor() { }

  confirmThis(title: string, message: string, type: ModalTypes, template: ModalTemplates, siFn: () => void, noFn: () => void, data: any | null = null) {
    this.setConfirmation(title, message, type, template, siFn, noFn, data);
  }

  setConfirmation(title: string, message: string, type: ModalTypes, template: ModalTemplates, siFn: () => void, noFn: () => void, data: any | null) {
    let that = this;
    this.subject.next({
      type: type,
      text: message,
      title: title,
      template: template,
      data: data,
      siFn: function () {
        siFn();
        that.subject.next(null); //this will close the modal
      },
      noFn: function () {
        noFn();
        that.subject.next(null);
      }
    });

  }

  getModalInfo(): Observable<any> {
    return this.subject.asObservable();
  }
}
